<template>
  <Navigation withExit @back="emit('back')" @exit="emit('exit')" />
  <Title>
    {{ i18n(translations.title) }}
    <template #subtitle>
      {{ i18n(translations.itemNotReceived) }}
    </template>
  </Title>

  <p class="text-static-default-low body-1 mb-24">
    {{ i18n(translations.intro) }}
  </p>

  <UploadEvidence
    :isLoading
    :mostUrgentTask
    :uploadLabel="i18n(translations.uploadFieldLabel)"
    @clear-errors="emit('clear-errors')"
    @submit="(values) => emit('submit', values)"
  >
    <RevInfoBlock
      class="w-1/2"
      :icon="IconLightbulb"
      :title="i18n(translations.hintTitle)"
      variant="default"
    >
      <p class="body-2 mb-3 pt-3">
        {{ i18n(translations.hintMessage) }}
      </p>

      <RevLink
        target="_blank"
        :to="{
          type: 'internal',
          name: ROUTE_NAMES.BADOOM.PDF.CERTIFICATE_TO_TRANSPORT_INVESTIGATION,
        }"
      >
        {{ i18n(translations.hintLink) }}
      </RevLink>
    </RevInfoBlock>
  </UploadEvidence>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconLightbulb } from '@ds/icons/IconLightbulb'

import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'
import { ROUTE_NAMES } from '~/constants/routes'

import Navigation from '../../../Navigation/Navigation.vue'
import Title from '../../../Title/Title.vue'
import UploadEvidence from '../components/UploadEvidence/UploadEvidence.vue'

import translations from './ItemNotReceived.translations'

defineProps<{
  isLoading: boolean
  mostUrgentTask?: OrderlineOpenTask
}>()

const emit = defineEmits(['back', 'exit', 'submit', 'clear-errors'])

const i18n = useI18n()
</script>
